import profilePictureFallback from '@tools/profile-picture-fallback';
import anchors from './anchor';

/**
 * @description Load atoms, useful when you change the DOM and need
 * to reload the JS customization layer
 */

export default function () {
  profilePictureFallback();
  anchors();
}
